import styled from '@emotion/styled'

import EvaluationBadge from 'components/feature/EvaluationBadge'

export const StyledEvaluationBadge = styled(EvaluationBadge)`
  margin-left: 5px;
  padding: 0; //ie11
`
